import * as React from "react";
import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation } from "react-router-dom";
import StartingPageContent from "../../components/StartingPage/StartingPageContent";
import CreateWordTable from "../CreateWordTable/CreateWordTable";
import EditableTable from "../CreateWordTable/EditableTable";
import Editor from "./Editor";
import HtmlToDocx from "./HtmlToDocx";

const ChapterEditor = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { reportId, chapter } = location.state;

  const onBackNavigation = () => {
    navigate(-1);
  };

  return (
    <StartingPageContent
      pageName={"Editor"}
      // description={chapter?.title + " - Rendi:" + chapter?.order}
      subtitle={chapter?.title + " - Rendi: " + chapter?.order}
      back
      onClick={onBackNavigation}
    >
      <Stack spacing={2}></Stack>
      <Editor chapter={chapter} reportId={reportId} />
      {/* <CreateWordTable />
      <EditableTable /> */}
      {/* <HtmlToDocx /> */}
    </StartingPageContent>
  );
};

export default ChapterEditor;
